module.exports = __webpack_public_path__ + "static/media/thumbnail.ad0155ad.jpg";